import React, { useState, useEffect, useRef } from "react";
import { deg2Sgn2 } from './util';
import { nanoid } from "nanoid";
import { CTX } from "../components/Store";
import "./TLEdit.css";
import 'react-tabs/style/react-tabs.css';
import data from "./tl-data.json";
import './Charts.css';

const AIInterps = () => {
  const { st, sendReq } = React.useContext(CTX);
  const [, updateComponent] = React.useState();
  const forceUpdateComponent = React.useCallback(() => updateComponent({}), [])
  const [contacts, setContacts] = useState(data);
  const [lookupname, setLookupname] = useState('');
  const [opts, setOpts] = useState(["Solar Arcs", "Transits", "Progressions"]);
  const [defval, setDefval] = useState("");
  const [ptype, setPtype] = useState('');
  const [pevtsCur, setPevtsCur] = useState(0);
  const [pEvent, setPEvent] = useState('');
  const [pName, setPName] = useState('');
  const [events, setEvents] = useState([]);
  const messageRef = useRef("");

  useEffect(() => {
    const myPara = document.getElementById('ai');

     myPara.innerText += st.x1;
     forceUpdateComponent();
}, [st.x1]);

useEffect(() => {
    const myPara = document.getElementById('ai');
    st.pevts = [];
    //st.name = null;
    messageRef.current = "";
    setLookupname('');
    myPara.innerText = "";
    forceUpdateComponent();
    return () => {
       st.x1 = "";
       st.x2 = "";
       st.x3 = "";
       st.x4 = "";
       st.x5 = "";
       st.x6 = "";
       st.x7 = "";
       st.x8 = "";
       st.x9 = "";
       st.x10 = "";
       st.x11 = "";
   };
}, []);

  const onSearchName = (e) => {
       e.preventDefault();

       if (e.target.value) {
           let lsReg = localStorage.getItem('sgaRegister');
           const req = `"{"event":"lookup-req","data":"{'srch': '${e.target.value}','auth': '${lsReg}','updt': true}"}"`;
           setLookupname(e.target.value);
           sendReq({ msg: req });
       } else {
           setLookupname('');
           st.lookups = [];
       }
       setDefval("");
  };

  const onLookup = (e, lookup) => {
      e.preventDefault();
	 
      if (lookup.name && lookup.name.length > 0) {
          setLookupname(lookup.name);
          const req = `"{"event":"ai-req","data":"{'id': ${lookup.id}}"}"`;
          sendReq({ msg: req });
      }
      const myPara = document.getElementById('ai');
      myPara.innerText = "";
      setLookupname(lookup.name);
      st.lookups = [];
      setDefval("");
  };

  //        <div className="clihdr">
  //	    </div>
  return (
        <>
	  <h2 style={{textAlign: "center"}}>AI Interpretation</h2>
          <div className="lu01b">
            <input
              className="inp01" type="text" value={lookupname}
              onChange={onSearchName} id="inp01" autocomplete="off"
              placeholder="Chart name..." />
           </div>
           <div className="lu02" id="lookups">
	       <ul className="dd01">
	          {""}
	          {st.lookups.map((lookup, index) => (
	            <li onClick={(e) => onLookup(e,lookup)} key={index}>
	              {""}
	              {lookup.name}
	            </li>
	          ))}
	        </ul>
	    </div>
	    <div className="app-container">
	      <p id="ai" name="ai">
	       It was a dark and stormy night...
	      </p>
                  
	      <div className="col text-center">
	         <span className='emsg'>{messageRef.current}</span>
	      </div>
	    </div>
	</>
	 );
};

export default AIInterps;

